import {useState} from 'react';
import {useQuery} from '@apollo/client';
import {Select, Spin} from 'antd';
import {GET_WEBSITE_OPTIONS} from '../sources/resolvers';
import {useDebounced} from './useDebounced';

// Picks one news website of an exchange by id. It searches news-service as
// the admin types, so a long list of websites stays usable. The chosen
// website keeps its name even when a later search no longer returns it.
const WebsitePicker = ({exchangeId, value, onChange, className, label}) => {
  const [search, setSearch] = useState('');
  const [chosen, setChosen] = useState(null);
  const query = useDebounced(search.trim());

  const {data, loading} = useQuery(GET_WEBSITE_OPTIONS, {
    variables: {exchangeId, search: query || undefined, limit: 20},
    skip: !exchangeId,
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });
  const found = data?.newsSources?.data || [];
  const options = [
    ...(value && chosen?.id === value && !found.some(w => w.id === value)
      ? [chosen]
      : []),
    ...found,
  ].map(website => ({value: website.id, label: website.name}));

  return (
    <Select
      allowClear
      showSearch
      aria-label={label}
      className={className}
      value={value}
      placeholder="All websites"
      filterOption={false}
      onSearch={setSearch}
      notFoundContent={loading ? <Spin size="small" /> : 'No website found'}
      onChange={(id, option) => {
        setChosen(id ? {id, name: option?.label} : null);
        setSearch('');
        onChange(id);
      }}
      options={options}
    />
  );
};

export default WebsitePicker;
